import type React from 'react';

import { format } from 'date-fns';
import isToday from 'date-fns/isToday';
import ru from 'date-fns/locale/ru';

import * as st from './styles.module.scss';

type Props = {
	date: Date;
};

export const DayDate: React.FC<Props> = ({ date }) => {
	return (
		<div className={st.date}>
			{isToday(date) ? (
				<div className={st.date__today}>
					<span className={st.date__today_day}>{format(date, 'dd', { locale: ru })}</span>
					<span className={st.date__today_month}>{format(date, 'MMMM yyyy', { locale: ru })}</span>
				</div>
			) : (
				format(date, 'dd MMMM yyyy', { locale: ru })
			)}
		</div>
	);
};

export const WeekDate: React.FC<Props> = ({ date }) => {
	return <div className={st.date}>{format(date, 'LLLL yyyy', { locale: ru })}</div>;
};
